import en from "./en";
import ru from "./ru";
import ua from "./ua";

export default {
  en,
  ru,
  ua
};
